export const tannerObjs = [
  { label: '歐洲牛皮', value: 'europeanSteer' },
  { label: '北海道成牛', value: 'northSteer' },
  { label: '成牛皮', value: 'steer' }
]

export const tannerTwObjs = [{ label: '美國成牛', value: 'usSteer' }]

const EUROPEAN_STEER_LEATHER_COLORS_TW = [
  { label: '棕色', value: 'cork', color: '#CE7220' },
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '橘紅色', value: 'redOrange', color: '#FF362E' },
  { label: '黑色', value: 'black', color: '#1E1E1E' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '深棕色', value: 'dBrown', color: '#350816' },
  { label: '巧克力色', value: 'chocolate', color: '#6b3b36' },
  { label: '檸檬黃', value: 'lemonYellow', color: '#D9D943' }
]

const NORTH_LEATHER_COLORS_TW = [
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '橘紅色', value: 'redOrange', color: '#FF362E' },
  { label: '黑色', value: 'black', color: '#1E1E1E' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '深棕色', value: 'dBrown', color: '#350816' },
  { label: '巧克力色', value: 'chocolate', color: '#6b3b36' },
  { label: '檸檬黃', value: 'lemonYellow', color: '#D9D943' },
  { label: '湖水綠', value: 'valorBlue', color: '#61BCBA' },
  { label: '綠色', value: 'mardiGras', color: '#4e734c' },
  { label: '蒂芬妮', value: 'tealGreen', color: '#317290' },
  { label: '紫色', value: 'purple', color: '#664785' },
  { label: '粉紅色', value: 'pink', color: '#F94C97' },
  { label: '灰色', value: 'gray', color: '#8A8C8C' }
]

const STEER_LEATHER_COLORS_TW = [
  { label: '棕色', value: 'cork', color: '#CE7220' },
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '橘紅色', value: 'redOrange', color: '#FF362E' },
  { label: '黑色', value: 'black', color: '#1E1E1E' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '黃色', value: 'yellow', color: '#E8C84B' },
  { label: '巧克力色', value: 'chocolate', color: '#6b3b36' },
  { label: '紅色', value: 'red', color: '#CB1527' },
  { label: '深藍色', value: 'navy', color: '#0d194a' },
  { label: '藍色', value: 'blue', color: '#0d42b5' },
  { label: '白色', value: 'white', color: '#fff' }
]

export const leatherColorObjsTw = [
  { label: '白色', value: 'white', color: '#fff' },
  { label: '灰色', value: 'gray', color: '#8A8C8C' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '黃色', value: 'yellow', color: '#E8C84B' },
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '橘紅色', value: 'redOrange', color: '#FF362E' },
  { label: '紅色', value: 'red', color: '#CB1527' },
  { label: '巧克力色', value: 'chocolate', color: '#6b3b36' },
  { label: '棕色', value: 'cork', color: '#CE7220' },
  { label: '粉紅色', value: 'pink', color: '#F94C97' },
  { label: '湖水綠', value: 'valorBlue', color: '#61BCBA' },
  { label: '藍色', value: 'blue', color: '#0d42b5' },
  { label: '深藍色', value: 'navy', color: '#0d194a' },
  { label: '深棕色', value: 'dBrown', color: '#350816' },
  { label: '紫色', value: 'purple', color: '#664785' },
  { label: '檸檬黃', value: 'lemonYellow', color: '#D9D943' },
  { label: '蒂芬妮', value: 'teal', color: '#317290' },
  { label: '綠色', value: 'mardiGras', color: '#4e734c' },
  { label: '黑色', value: 'black', color: '#1E1E1E' }
]

const commonPartsTwObjs = [
  { label: '全部', value: 'all', order: 0 },
  { label: '接球面', value: 'catchFace', order: 1 },
  { label: '球擋', value: 'web', order: 2 },
  { label: '滾邊', value: 'edge', order: 4 },
  { label: '大拇指裡帶', value: 'thumbHook', order: 5 },
  { label: '小指裡帶', value: 'littleHook', order: 6 },
  { label: '護指套片/指片', value: 'indexCover', order: 7 },
  { label: '内裡', value: 'linings', order: 8 }
]

const backBeltStyleGloveTwNoBeltObjs = [
  { label: '拇指1', value: 'thumbOut', order: 9 },
  { label: '拇指2', value: 'thumbWeb', order: 10 },
  { label: '食指3', value: 'indexWeb', order: 11 },
  { label: '食指4', value: 'indexMiddle', order: 12 },
  { label: '中指5', value: 'middleIndex', order: 13 },
  { label: '中指6', value: 'middleRing', order: 14 },
  { label: '無名指7', value: 'ringMiddle', order: 15 },
  { label: '無名指8', value: 'ringLittle', order: 16 },
  { label: '小指9', value: 'littleRing', order: 17 },
  { label: '小指10', value: 'littleOut', order: 18 }
]

const backBeltStyleGloveTwObjs = [...backBeltStyleGloveTwNoBeltObjs, { label: '背帶', value: 'listBelt', order: 19 }]

const backCrownBackGloveTwObjs = [
  { label: '拇指1', value: 'thumbOut', order: 9 },
  { label: '拇指2', value: 'thumbWeb', order: 10 },
  { label: '食指3', value: 'indexWeb', order: 11 },
  { label: '食指4・中指5', value: 'indexLeftMiddleRight', order: 12 },
  { label: '中指6・無名指7', value: 'middleLeftRingRight', order: 13 },
  { label: '無名指8・小指9', value: 'ringLeftLittleRight', order: 14 },
  { label: '小指10', value: 'littleOut', order: 15 },
  { label: '背帶', value: 'listBelt', order: 16 }
]

const backGloveUsBackEnObjs = [
  { label: '拇指1', value: 'thumbOut', order: 9 },
  { label: '拇指2', value: 'thumbWeb', order: 10 },
  { label: '背帶', value: 'thumbRoot', order: 11 },
  { label: '食指3', value: 'indexWeb', order: 12 },
  { label: '食指4', value: 'indexMiddle', order: 13 },
  { label: '中指5', value: 'middleIndex', order: 14 },
  { label: '中指6', value: 'middleRing', order: 15 },
  { label: '無名指7', value: 'ringMiddle', order: 16 },
  { label: '無名指8', value: 'ringLittle', order: 17 },
  { label: '小指9', value: 'littleRing', order: 18 },
  { label: '小指10', value: 'littleOut', order: 19 }
]
const backFirstBackGloveTwObjs = [
  { label: '拇指1', value: 'thumbOut', order: 9 },
  { label: '拇指2・食指・中指5', value: 'thumbIndexMiddle', order: 10 },
  { label: '中指6・無名指7', value: 'middleLeftRingRight', order: 11 },
  { label: '無名指8・小指9', value: 'ringLeftLittleRight', order: 12 },
  { label: '小指10', value: 'littleOut', order: 13 },
  { label: '手背調整帶', value: 'listBelt', order: 14 }
]

const backFirstMittNoBeltTwObjs = [
  { label: '大拇指', value: 'thumb', order: 9 },
  { label: 'U型虎口', value: 'underWeb', order: 10 },
  { label: '手背四指', value: 'boomerang', order: 11 }
]
const backFirstMittTwObjs = [
  { label: '背帶', value: 'listBelt', order: 9 },
  { label: '大拇指', value: 'thumb', order: 10 },
  { label: 'U型虎口', value: 'underWeb', order: 11 },
  { label: '手背四指', value: 'boomerang', order: 12 }
]

const backOfRegularBackStyleCatcherMittTwObjs = [
  { label: '拇指・食指・中指5', value: 'thumbIndexMiddleRight', order: 9 },
  { label: '中指6・無名指', value: 'middleLeftRing', order: 10 },
  { label: '食指開口', value: 'indexFingerTipOut', order: 11 },
  { label: '小指10', value: 'littleOut', order: 12 },
  { label: '手背大片', value: 'fingerStand', order: 13 },
  { label: '手背調整帶', value: 'listBelt', order: 14 }
]

const backOfBeltBackStyleCatcherMittTwObjs = [
  { label: '拇指・食指・中指5', value: 'thumbIndexMiddleRight', order: 9 },
  { label: '中指6・無名指・小指', value: 'middleLeftRingLittle', order: 10 },
  { label: '手背大片', value: 'fingerStand' }
]

export const BINDING_COLORS_TW = [
  { label: '棕色', value: 'cork', color: '#CE7220' },
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '橘紅色', value: 'redOrange', color: '#FF362E' },
  { label: '黑色', value: 'black', color: '#1E1E1E' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '黃色', value: 'yellow', color: '#E8C84B' },
  { label: '檸檬黃', value: 'lemonYellow', color: '#D9D943' },
  { label: '巧克力色', value: 'chocolate', color: '#6b3b36' },
  { label: '深棕色', value: 'dBrown', color: '#350816' },
  { label: '紅色', value: 'red', color: '#CB1527' },
  { label: '藍色', value: 'blue', color: '#0d42b5' },
  { label: '深藍色', value: 'navy', color: '#0d194a' },
  { label: '湖水綠', value: 'valorBlue', color: '#61BCBA' },
  { label: '綠色', value: 'mardiGras', color: '#4e734c' },
  { label: '蒂芬妮', value: 'tealGreen', color: '#317290' },
  { label: '紫色', value: 'purple', color: '#664785' },
  { label: '白色', value: 'white', color: '#ffffff' }
]

export const listLiningsMaterialTwObjs = [
  { label: '羊毛(白色)', value: 'moutonWhite', color: '#fff', imageUrl: '/atoms/colorSettings/mouton/white.jpg' },
  { label: '羊毛(黑色)', value: 'moutonBlack', color: '#1a1a1a', imageUrl: '/atoms/colorSettings/mouton/black.jpg' }
]

export const dispatchTwObjects = {
  linings: leatherColorObjsTw,
  listLiningsMaterial: listLiningsMaterialTwObjs,
  all: leatherColorObjsTw,
  catchFace: leatherColorObjsTw,
  web: leatherColorObjsTw,
  web2: leatherColorObjsTw,
  edge: BINDING_COLORS_TW,
  thumbHook: leatherColorObjsTw,
  thumbWebAndIndexWeb: leatherColorObjsTw,
  littleHook: leatherColorObjsTw,
  indexCover: leatherColorObjsTw,
  thumbOut: leatherColorObjsTw,
  thumbWeb: leatherColorObjsTw,
  thumbRoot: leatherColorObjsTw,
  thumbIndexMiddle: leatherColorObjsTw,
  thumbIndexMiddleRight: leatherColorObjsTw,
  indexWeb: leatherColorObjsTw,
  indexMiddle: leatherColorObjsTw,
  middleIndex: leatherColorObjsTw,
  middleRing: leatherColorObjsTw,
  middleLeftRing: leatherColorObjsTw,
  middleLeftRingRight: leatherColorObjsTw,
  middleLeftRingLittle: leatherColorObjsTw,
  ringMiddle: leatherColorObjsTw,
  ringLittle: leatherColorObjsTw,
  ringLeftLittleRight: leatherColorObjsTw,
  littleRing: leatherColorObjsTw,
  littleOut: leatherColorObjsTw,
  listBelt: leatherColorObjsTw,
  thumb: leatherColorObjsTw,
  boomerang: leatherColorObjsTw,
  underWeb: leatherColorObjsTw,
  catchFaceTarget: leatherColorObjsTw,
  indexLeftMiddleRight: leatherColorObjsTw,
  indexAndMiddle: leatherColorObjsTw,
  fingerStand: leatherColorObjsTw,
  indexFingerTipOut: leatherColorObjsTw
}

export const dispatchEuropeanSteerTw = {
  linings: EUROPEAN_STEER_LEATHER_COLORS_TW,
  all: EUROPEAN_STEER_LEATHER_COLORS_TW,
  catchFace: EUROPEAN_STEER_LEATHER_COLORS_TW,
  web: EUROPEAN_STEER_LEATHER_COLORS_TW,
  web2: EUROPEAN_STEER_LEATHER_COLORS_TW,
  edge: BINDING_COLORS_TW,
  thumbHook: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumbWebAndIndexWeb: EUROPEAN_STEER_LEATHER_COLORS_TW,
  littleHook: EUROPEAN_STEER_LEATHER_COLORS_TW,
  indexCover: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumbOut: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumbWeb: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumbRoot: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumbIndexMiddle: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumbIndexMiddleRight: EUROPEAN_STEER_LEATHER_COLORS_TW,
  indexWeb: EUROPEAN_STEER_LEATHER_COLORS_TW,
  indexMiddle: EUROPEAN_STEER_LEATHER_COLORS_TW,
  middleIndex: EUROPEAN_STEER_LEATHER_COLORS_TW,
  middleRing: EUROPEAN_STEER_LEATHER_COLORS_TW,
  middleLeftRing: EUROPEAN_STEER_LEATHER_COLORS_TW,
  middleLeftRingRight: EUROPEAN_STEER_LEATHER_COLORS_TW,
  middleLeftRingLittle: EUROPEAN_STEER_LEATHER_COLORS_TW,
  ringMiddle: EUROPEAN_STEER_LEATHER_COLORS_TW,
  ringLittle: EUROPEAN_STEER_LEATHER_COLORS_TW,
  ringLeftLittleRight: EUROPEAN_STEER_LEATHER_COLORS_TW,
  littleRing: EUROPEAN_STEER_LEATHER_COLORS_TW,
  littleOut: EUROPEAN_STEER_LEATHER_COLORS_TW,
  listBelt: EUROPEAN_STEER_LEATHER_COLORS_TW,
  thumb: EUROPEAN_STEER_LEATHER_COLORS_TW,
  boomerang: EUROPEAN_STEER_LEATHER_COLORS_TW,
  underWeb: EUROPEAN_STEER_LEATHER_COLORS_TW,
  catchFaceTarget: EUROPEAN_STEER_LEATHER_COLORS_TW,
  indexLeftMiddleRight: EUROPEAN_STEER_LEATHER_COLORS_TW,
  indexAndMiddle: EUROPEAN_STEER_LEATHER_COLORS_TW,
  fingerStand: EUROPEAN_STEER_LEATHER_COLORS_TW,
  indexFingerTipOut: EUROPEAN_STEER_LEATHER_COLORS_TW
}

// 硬式・軟式
export const dispatchNorthSteerTw = {
  linings: NORTH_LEATHER_COLORS_TW,
  all: NORTH_LEATHER_COLORS_TW,
  catchFace: NORTH_LEATHER_COLORS_TW,
  web: NORTH_LEATHER_COLORS_TW,
  web2: NORTH_LEATHER_COLORS_TW,
  edge: BINDING_COLORS_TW,
  thumbHook: NORTH_LEATHER_COLORS_TW,
  thumbWebAndIndexWeb: NORTH_LEATHER_COLORS_TW,
  littleHook: NORTH_LEATHER_COLORS_TW,
  indexCover: NORTH_LEATHER_COLORS_TW,
  thumbOut: NORTH_LEATHER_COLORS_TW,
  thumbWeb: NORTH_LEATHER_COLORS_TW,
  thumbRoot: NORTH_LEATHER_COLORS_TW,
  thumbIndexMiddle: NORTH_LEATHER_COLORS_TW,
  thumbIndexMiddleRight: NORTH_LEATHER_COLORS_TW,
  indexWeb: NORTH_LEATHER_COLORS_TW,
  indexMiddle: NORTH_LEATHER_COLORS_TW,
  middleIndex: NORTH_LEATHER_COLORS_TW,
  middleRing: NORTH_LEATHER_COLORS_TW,
  middleLeftRing: NORTH_LEATHER_COLORS_TW,
  middleLeftRingRight: NORTH_LEATHER_COLORS_TW,
  middleLeftRingLittle: NORTH_LEATHER_COLORS_TW,
  ringMiddle: NORTH_LEATHER_COLORS_TW,
  ringLittle: NORTH_LEATHER_COLORS_TW,
  ringLeftLittleRight: NORTH_LEATHER_COLORS_TW,
  littleRing: NORTH_LEATHER_COLORS_TW,
  littleOut: NORTH_LEATHER_COLORS_TW,
  listBelt: NORTH_LEATHER_COLORS_TW,
  thumb: NORTH_LEATHER_COLORS_TW,
  boomerang: NORTH_LEATHER_COLORS_TW,
  underWeb: NORTH_LEATHER_COLORS_TW,
  catchFaceTarget: NORTH_LEATHER_COLORS_TW,
  indexLeftMiddleRight: NORTH_LEATHER_COLORS_TW,
  indexAndMiddle: NORTH_LEATHER_COLORS_TW,
  fingerStand: NORTH_LEATHER_COLORS_TW,
  indexFingerTipOut: NORTH_LEATHER_COLORS_TW
}

// 硬式・軟式
export const dispatchSteerTw = {
  linings: STEER_LEATHER_COLORS_TW,
  all: STEER_LEATHER_COLORS_TW,
  catchFace: STEER_LEATHER_COLORS_TW,
  web: STEER_LEATHER_COLORS_TW,
  web2: STEER_LEATHER_COLORS_TW,
  edge: BINDING_COLORS_TW,
  thumbHook: STEER_LEATHER_COLORS_TW,
  thumbWebAndIndexWeb: STEER_LEATHER_COLORS_TW,
  littleHook: STEER_LEATHER_COLORS_TW,
  indexCover: STEER_LEATHER_COLORS_TW,
  thumbOut: STEER_LEATHER_COLORS_TW,
  thumbWeb: STEER_LEATHER_COLORS_TW,
  thumbRoot: STEER_LEATHER_COLORS_TW,
  thumbIndexMiddle: STEER_LEATHER_COLORS_TW,
  thumbIndexMiddleRight: STEER_LEATHER_COLORS_TW,
  indexWeb: STEER_LEATHER_COLORS_TW,
  indexMiddle: STEER_LEATHER_COLORS_TW,
  middleIndex: STEER_LEATHER_COLORS_TW,
  middleRing: STEER_LEATHER_COLORS_TW,
  middleLeftRing: STEER_LEATHER_COLORS_TW,
  middleLeftRingRight: STEER_LEATHER_COLORS_TW,
  middleLeftRingLittle: STEER_LEATHER_COLORS_TW,
  ringMiddle: STEER_LEATHER_COLORS_TW,
  ringLittle: STEER_LEATHER_COLORS_TW,
  ringLeftLittleRight: STEER_LEATHER_COLORS_TW,
  littleRing: STEER_LEATHER_COLORS_TW,
  littleOut: STEER_LEATHER_COLORS_TW,
  listBelt: STEER_LEATHER_COLORS_TW,
  thumb: STEER_LEATHER_COLORS_TW,
  boomerang: STEER_LEATHER_COLORS_TW,
  underWeb: STEER_LEATHER_COLORS_TW,
  catchFaceTarget: STEER_LEATHER_COLORS_TW,
  indexLeftMiddleRight: STEER_LEATHER_COLORS_TW,
  indexAndMiddle: STEER_LEATHER_COLORS_TW,
  fingerStand: STEER_LEATHER_COLORS_TW,
  indexFingerTipOut: STEER_LEATHER_COLORS_TW
}

export const laceColorTwObjs = [
  { label: '棕色', value: 'cork', color: '#CE7220' },
  { label: '橘色', value: 'orange', color: '#FF6C23' },
  { label: '橘紅色', value: 'redOrange', color: '#FF362E' },
  { label: '黑色', value: 'black', color: '#1E1E1E' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '白色', value: 'white', color: '#ffffff' },
  { label: '深藍色', value: 'navy', color: '#0d194a' },
  { label: '紅色', value: 'red', color: '#CB1527' },
  { label: '蒂芬妮', value: 'tealGreen', color: '#317290' },
  { label: '深棕色', value: 'dBrown', color: '#350816' },
  { label: '巧克力色', value: 'chocolate', color: '#6b3b36' },
  { label: '檸檬黃', value: 'lemonYellow', color: '#D9D943' }
]

export const stitchColorTwObjs = [
  { label: '黑色', value: 'black', color: '#0a0a0a' },
  { label: '橘色', value: 'orange', color: '#e37d00' },
  { label: '黃色', value: 'yellow', color: '#debd00' },
  { label: '棕色', value: 'kurk', color: '#CE7220' },
  { label: '粉紅色', value: 'pink', color: '#ff1493' },
  { label: '天藍色', value: 'skyBlue', color: '#4EB5DC' },
  { label: '奶油色', value: 'camelBrown', color: '#D7CEA5' },
  { label: '紅色', value: 'red', color: '#c70000' },
  { label: '深藍色', value: 'navy', color: '#363C53' },
  { label: '藍色', value: 'blue', color: '#002bff' },
  { label: '白色', value: 'white', color: '#eee' },
  { label: '綠色', value: 'green', color: '#009c09' },
  { label: '紫色', value: 'purple', color: '#6a1ca3' },
  { label: '灰色', value: 'gray', color: '#828282' },
  { label: '巧克力色', value: 'chocolate', color: '#591d15' },
  { label: '淺綠色', value: 'bGreen', color: '#60D45E' }
]

export const hamidashiTwObjs = [
  { label: '二榔皮(白色)', value: 'kirihamiWhite', color: '#fff' },
  { label: '反折(棕色)', value: 'cork', color: '#CE7220' },
  { label: '反折(橘色)', value: 'orange', color: '#FF6C23' },
  { label: '反折(橘紅色)', value: 'redOrange', color: '#FF362E' },
  { label: '反折(黑色)', value: 'black', color: '#1E1E1E' },
  { label: '反折(奶油色)', value: 'camelBrown', color: '#D7CEA5' },
  { label: '反折(黃色)', value: 'yellow', color: '#E8C84B' },
  { label: '反折(檸檬黃)', value: 'lemonYellow', color: '#D9D943' },
  { label: '反折(巧克力色)', value: 'chocolate', color: '#6b3b36' },
  { label: '反折(深棕色)', value: 'dBrown', color: '#350816' },
  { label: '反折(紅色)', value: 'red', color: '#CB1527' },
  { label: '反折(藍色)', value: 'blue', color: '#0d42b5' },
  { label: '反折(深藍色)', value: 'navy', color: '#0d194a' },
  { label: '反折(湖水綠)', value: 'valorBlue', color: '#61BCBA' },
  { label: '反折(綠色)', value: 'mardiGras', color: '#4e734c' },
  { label: '反折(蒂芬妮)', value: 'tealGreen', color: '#317290' },
  { label: '反折(紫色)', value: 'purple', color: '#664785' },
  { label: '反折(粉紅色)', value: 'pink', color: '#F94C97' },
  { label: '反折(灰色)', value: 'gray', color: '#8A8C8C' },
  { label: '反折(白色)', value: 'white', color: '#fff' }
]

const noWelting = { label: '無夾條', value: 'none', color: '#fff' }
export const hamidashiAllTwObjs = [noWelting, ...hamidashiTwObjs]

export const hamidashiForCatcherTwObjs = [noWelting, ...hamidashiTwObjs]

export const atomsLabelTwObjs = [
  { label: '黒x金x綠', value: 'aaa', imageUrl: '/atoms/labels/a.jpg' },
  { label: '黑x金x金', value: 'ccc', imageUrl: '/atoms/labels/c.jpg' },
  { label: '深藍x紅x金', value: 'eee', imageUrl: '/atoms/labels/e.jpg' },
  { label: '黑x金x銀', value: 'ggg', imageUrl: '/atoms/labels/g.jpg' },
  { label: '黑x金x藍', value: 'iii', imageUrl: '/atoms/labels/i.jpg' },
  { label: '黑x白金x金', value: 'jjj', imageUrl: '/atoms/labels/j.jpg' },
  { label: '黑x黑x黑', value: 'kkk', imageUrl: '/atoms/labels/k.jpg' },
  { label: '黑x金x粉', value: 'uuu', imageUrl: '/atoms/labels/u.jpg' },
  { label: '黑x矽金', value: 'lll', imageUrl: '/atoms/labels/l.jpg' },
  { label: '黒x矽白金', value: 'mmm', imageUrl: '/atoms/labels/m.jpg' },
  { label: '黒x矽黒閃粉', value: 'nnn', imageUrl: '/atoms/labels/n.jpg' },
  { label: '黒x矽藍', value: 'ooo', imageUrl: '/atoms/labels/o.jpg' },
  { label: '黒x矽紫', value: 'ppp', imageUrl: '/atoms/labels/p.jpg' },
  { label: '黒x矽紅', value: 'qqq', imageUrl: '/atoms/labels/q.jpg' },
  { label: '黒x矽綠', value: 'rrr', imageUrl: '/atoms/labels/r.jpg' },
  { label: '黒x矽銀', value: 'zzz', imageUrl: '/atoms/labels/z.jpg' }
]

// 手套部位相關的物件
export const gloveBeltBackPartsTwObjs = [...commonPartsTwObjs, ...backBeltStyleGloveTwObjs]

export const gloveBeltBackPartsNoBeltTwObjs = [...commonPartsTwObjs, ...backBeltStyleGloveTwNoBeltObjs]

export const gloveCrownBackPartsTwObjs = [...commonPartsTwObjs, ...backCrownBackGloveTwObjs]

export const gloveFirstBackPartsTwObjs = [...commonPartsTwObjs, ...backFirstBackGloveTwObjs]

export const gloveUsBackPartsTwObjs = [...commonPartsTwObjs, ...backGloveUsBackEnObjs]

export const catcherMittBackPartsTwObjs = [...commonPartsTwObjs, ...backBeltStyleGloveTwObjs]

export const catcherMittCatchFaceTwObjs = [...commonPartsTwObjs, { label: '側片', value: 'catchFaceTarget', order: 9 }]

export const catcherMittBackofBeltBackStylePartsTwObjs = [...commonPartsTwObjs, ...backOfBeltBackStyleCatcherMittTwObjs]

export const catcherMittBackofRegularBackStylePartsTwObjs = [...commonPartsTwObjs, ...backOfRegularBackStyleCatcherMittTwObjs]

export const firstMittBackPartsTwObjs = [...commonPartsTwObjs, ...backFirstMittTwObjs]

export const firstMittBackPartsNoBeltTwObjs = [...commonPartsTwObjs, ...backFirstMittNoBeltTwObjs]

export const catchFacePartsTwObjs = commonPartsTwObjs

export const uBackTwObjs = [{ label: 'U型背面', value: 'uBack' }]

export const tw2JaColorPartsTranslates = [
  // カラー
  { taiwan: '棕色', japanese: 'コルク' },
  { taiwan: '黑色', japanese: 'ブラック' },
  { taiwan: '橘色', japanese: 'オレンジ' },
  { taiwan: '奶油色', japanese: 'Cブラウン' },
  { taiwan: '深棕色', japanese: 'Dブラウン' },
  { taiwan: '紅色', japanese: 'レッド' },
  { taiwan: '粉紅色', japanese: 'ピンク' },
  { taiwan: '橘紅色', japanese: 'レッドオレンジ' },
  { taiwan: '蒂芬妮', japanese: 'ティールグリーン' },
  { taiwan: '深藍色', japanese: 'ネイビー' },
  { taiwan: '藍色', japanese: 'ブルー' },
  { taiwan: '湖水綠', japanese: 'ベイラーブルー' },
  { taiwan: '綠色', japanese: 'マディグラス' },
  { taiwan: '紫色', japanese: 'パープル' },
  { taiwan: '白色', japanese: 'ホワイト' },
  { taiwan: '黃色', japanese: 'イエロー' },
  { taiwan: '檸檬黃', japanese: 'レモンイエロー' },
  { taiwan: '巧克力色', japanese: 'チョコレート' },
  { taiwan: '淺綠色', japanese: 'Bグリーン' },

  // パーツ
  { taiwan: '全部', japanese: '全体' },
  { taiwan: '接球面', japanese: '捕球面' },
  { taiwan: '球擋上', japanese: 'ウェブ' },
  { taiwan: '球擋2', japanese: 'ウェブ2' },
  { taiwan: '夾條', japanese: 'ヘリ革' },
  { taiwan: '大拇指裡帶', japanese: '親指掛け紐' },
  { taiwan: '小指裡帶', japanese: '小指掛け紐' },
  { taiwan: '護指套片/指片', japanese: '指カバー/指当て' },
  { taiwan: '内裡', japanese: '裏革' },
  { taiwan: '大拇指', japanese: '親指' }, // ファーストミット
  { taiwan: 'U型虎口', japanese: 'ウェブ下' }, // ファーストミット
  { taiwan: '手背四指', japanese: 'ブーメラン' }, // ファーストミット
  { taiwan: '拇指1', japanese: '親指1' },
  { taiwan: '拇指2', japanese: '親指2' },
  { taiwan: '食指3', japanese: '人差指3' },
  { taiwan: '食指4', japanese: '人差指4' },
  { taiwan: '中指5', japanese: '中指5' },
  { taiwan: '中指6', japanese: '中指6' },
  { taiwan: '無名指7', japanese: '薬指7' },
  { taiwan: '無名指8', japanese: '薬指8' },
  { taiwan: '小指9', japanese: '小指9' },
  { taiwan: '小指10', japanese: '小指10' },
  { taiwan: '背帶', japanese: 'バンド' },
  { taiwan: '手背調整帶', japanese: 'バンド' },
  { taiwan: '食指4・中指5', japanese: '人差指4・中指5' },
  { taiwan: '中指6・無名指7', japanese: '中指6・薬指7' },
  { taiwan: '無名指8・小指9', japanese: '薬指8・小指9' },
  { taiwan: '拇指2・食指・中指5', japanese: '親指2・人差指・中指5' },
  { taiwan: '側片', japanese: 'ターゲット' },
  { taiwan: 'U型背面', japanese: 'Uバック' },
  { taiwan: '手背大片', japanese: '背面台' },
  { taiwan: '食指開口', japanese: '指出し' },
  { taiwan: '手背調整帶', japanese: 'ベルト' },
  { taiwan: '滾邊', japanese: 'ヘリ革' },

  // ムートン
  { taiwan: '羊毛(白色)', japanese: 'ムートン(ホワイト)' },
  { taiwan: '羊毛(黑色)', japanese: 'ムートン(ブラック)' },
  // ハミダシ
  { taiwan: '無夾條', japanese: 'ハミダシなし' },
  { taiwan: '二榔皮(白色)', japanese: '切りハミ(ホワイト)' },
  { taiwan: '反折(棕色)', japanese: 'ハミダシ(コルク)' },
  { taiwan: '反折(橘色)', japanese: 'ハミダシ(オレンジ)' },
  { taiwan: '反折(橘紅色)', japanese: 'ハミダシ(レッドオレンジ)' },
  { taiwan: '反折(黑色)', japanese: 'ハミダシ(ブラック)' },
  { taiwan: '反折(奶油色)', japanese: 'ハミダシ(Cブラウン)' },
  { taiwan: '反折(黃色)', japanese: 'ハミダシ(イエロー)' },
  { taiwan: '反折(檸檬黃)', japanese: 'ハミダシ(レモンイエロー)' },
  { taiwan: '反折(巧克力色)', japanese: 'ハミダシ(チョコレート)' },
  { taiwan: '反折(深棕色)', japanese: 'ハミダシ(Dブラウン)' },
  { taiwan: '反折(紅色)', japanese: 'ハミダシ(レッド)' },
  { taiwan: '反折(藍色)', japanese: 'ハミダシ(ブルー)' },
  { taiwan: '反折(深藍色)', japanese: 'ハミダシ(ネイビー)' },
  { taiwan: '反折(湖水綠)', japanese: 'ハミダシ(ベイラーブルー)' },
  { taiwan: '反折(綠色)', japanese: 'ハミダシ(マディグラス)' },
  { taiwan: '反折(蒂芬妮)', japanese: 'ハミダシ(ティールグリーン)' },
  { taiwan: '反折(紫色)', japanese: 'ハミダシ(パープル)' },
  { taiwan: '反折(粉紅色)', japanese: 'ハミダシ(ピンク)' },
  { taiwan: '反折(灰色)', japanese: 'ハミダシ(グレー)' },
  { taiwan: '反折(白色)', japanese: 'ハミダシ(ホワイト)' },

  // ラベル
  { taiwan: '黒x金x綠', japanese: '黒xゴールドxグリーン' },
  { taiwan: '黑x金x金', japanese: '黒xゴールドxゴールド' },
  { taiwan: '深藍x紅x金', japanese: 'ネイビーx赤xゴールド' },
  { taiwan: '黑x金x銀', japanese: '黒xゴールドxシルバー' },
  { taiwan: '黑x金x藍', japanese: '黒xゴールドxブルー' },
  { taiwan: '黑x白金x金', japanese: '黒xプラチナゴールドxゴールド' },
  { taiwan: '黑x黑x黑', japanese: '黒x黒x黒' },
  { taiwan: '黑x金x粉', japanese: '黒xゴールドxピンク' },
  { taiwan: '黑x矽金', japanese: '黒xシリコンゴールド' },
  { taiwan: '黒x矽白金', japanese: '黒xシリコンプラチナ' },
  { taiwan: '黒x矽黒閃粉', japanese: '黒xシリコンブラックラメ' },
  { taiwan: '黒x矽藍', japanese: '黒xシリコンブルー' },
  { taiwan: '黒x矽紫', japanese: '黒xシリコンパープル' },
  { taiwan: '黒x矽紅', japanese: '黒xシリコンレッド' },
  { taiwan: '黒x矽綠', japanese: '黒xシリコングリーン' },
  { taiwan: '黒x矽銀', japanese: '黒xシリコンシルバー' }
]
